export enum QuoteStatusTypes {
    APPROVAL = "approval",
    PENDING = "pending",
    REJECTED = "rejected",
    COMPLETED = "completed",
}

export type QuoteStatusType =
    | QuoteStatusTypes.APPROVAL
    | QuoteStatusTypes.PENDING
    | QuoteStatusTypes.REJECTED
    | QuoteStatusTypes.COMPLETED;

export interface QuoteStatus {
    /* Process status type */
    type: QuoteStatusType;
    /* Localized status message */
    text: string;
}

export interface QuoteItem {
    /* Unique identifier of the return entry */
    orderNumber: string;
    /* Current process status */
    status: QuoteStatus;
    /* Date when the return process was created */
    createdAt: string;
    /* Number of positions included in the return */
    positions: number;
    /* Order Total sum */
    orderTotal: string;
    /* Machine assignment */
    machine: string;
    /* URL for downloading quote infos */
    downloadLink: string;
    /* URL of the quote detail page */
    detailLink: string;
}

export interface QuoteReturnResponse {
    /* API endpoint form requesting further results */
    nextPage?: string | null;
    /* The total number of results */
    totalCount: string;
    /* The number of results with current filter applied */
    filteredCount: number;
    /* The result items */
    items: QuoteItem[];
}
